import React from "react";
import { Col, Row, Input, Label } from "reactstrap";

import MySelect from "./test";

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

const CasosEditComponent = ({
  casoDetallado,
  groups,
  handleSelectGrupoTecnico,
  grupoTecnicoFilter1,
  grupotTecnico,
  filteredtest,
  sd,
  setFormData,
  formData,
  onChangeFecha,
  onChangeHoraEntrada,
  onChangeHoraSalida,
  contact,
  onChange,
  casoDetalles,
}) => {


  const URL = process.env.REACT_APP_API_URL.split("/api").join("");
  const foto =
    casoDetallado.images && casoDetallado.images.length > 0
      ? casoDetallado.images.map((image) => image)
      : [];

  //Options
  const TipoVisita = [
    { label: "VISITA CONTRATO", value: "VISITA CONTRATO" },
    { label: "VISITA ADICIONAL", value: "VISITA ADICIONAL" },
    { label: "VENTA", value: "VENTA" },
    { label: "GARANTIA", value: "GARANTIA" },
    { label: "REVISION O REPARACION", value: "REVISION O REPARACION" },
    { label: "ENTREGA", value: "ENTREGA" },
    {
      label: "LEVANTAMIENTO DE INFORMACION",
      value: "LEVANTAMIENTO DE INFORMACION",
    },
    { label: "MANTENIMIENTO PREVENTIVO", value: "MANTENIMIENTO PREVENTIVO" },
    { label: "MANTENIMIENTO CORRECTIVO", value: "MANTENIMIENTO CORRECTIVO" },
  ];

  const TipoServicio = [
    { label: "PRESENCIAL", value: "PRESENCIAL" },
    { label: "REMOTO", value: "REMOTO" },
    { label: "MIXTO", value: "MIXTO" },
  ];

  return (
    <React.Fragment>
      <Row className="col-lg-12 justify-content-center ">
        <Col lg={12} className="mb-3">
          <Label
            for="tecnico_asignado"
            className="col-form-label col-sm-4 d-flex"
          >
            <strong>Contacto o PreContacto</strong>
          </Label>

          <Input
            name="contacto"
            defaultValue={
              casoDetallado.contacto
                ? casoDetallado.contacto
                : casoDetallado.pre_contacto
                ? casoDetallado.pre_contacto
                : null
            }
            disabled={true}
          ></Input>

          <Label for="tipo_visita" className="form-label mt-2">
            Tipo de Visita
          </Label>

          <select
            className="form-select"
            defaultValue={casoDetallado.tipo_visita}
            name="tipo_visita"
            disabled={true}
            autoFocus
            onChange={onChange}
          >
            {TipoVisita &&
              TipoVisita.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
          </select>
          <Label for="tipo_servicio" className="form-label mt-2">
            Tipo de Servicio
          </Label>
          <select
            className="form-select"
            onChange={onChange}
            id="tipo_servicio"
            name="tipo_servicio"
            defaultValue={casoDetallado.tipo_servicio}
            disabled={true}
            autoFocus
          >
            {TipoServicio &&
              TipoServicio.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
          </select>

          <Label
            for="detallesServicio"
            className="col-form-label col-sm-4 d-flex"
          >
            <strong>Datos del Servicio </strong>
          </Label>

          <textarea
            className="form-control"
            id="datosServicio"
            name="datosServicio"
            type="textarea"
            onChange={onChange}
            rows="2"
            defaultValue={casoDetallado.datosServicio}
            disabled={true}
          />
          <Label
            for="detallesServicio"
            className="col-form-label col-sm-4 d-flex"
          >
            <strong>Detalles del Servicio </strong>
          </Label>

          <textarea
            className="form-control"
            id="detallesServicio"
            name="detallesServicio"
            type="textarea"
            onChange={onChange}
            rows="2"
            defaultValue={casoDetallado.detallesServicio}
            disabled={true}
          />

          <Label for="observaciones" className="col-form-label col-sm-4 d-flex">
            <strong>Observaciones </strong>
          </Label>

          <textarea
            className="form-control"
            id="observaciones"
            name="observaciones"
            type="textarea"
            rows="4"
            defaultValue={casoDetallado.observaciones}
            disabled={true}
          />

          {/* {Array.isArray(casoDetalles)? casoDetalles.map(item=> {

                                                          return (
                                                            
                                                          )
                                                        })} */}

          <Row className="col-lg-12 justify-content-center mt-2">
            <Col lg={6} className="mb-10">
              {foto.length !== 0 ? (
                <div style={{ display: "flex" }}>
                  {foto.map((image, index) => (
                    <img
                      key={index}
                      src={`${URL}/media/${image}`}
                      alt=""
                      style={{
                        display: "block",
                        margin: "0 auto",
                        border: "2px dashed",
                        width: "150px",
                      }}
                    />
                  ))}
                </div>
              ) : null}
            </Col>
          </Row>

          <Label for="grupo_tecnico" className="col-form-label col-sm-4 d-flex">
            <strong>Grupo de Tecnicos</strong>
          </Label>

          <MySelect
            id="grupo_tecnico"
            isDisabled={
              casoDetallado.estatus === "FINALIZAR"
                ? true
                : groups === "SuperAdmin" || groups === "Supervisor"  || groups === "INGENIERO"
                ? false
                : true
            }
            name="grupo_tecnico"
            onChange={handleSelectGrupoTecnico}
            defaultValue={
              Array.isArray(grupoTecnicoFilter1)
                ? grupoTecnicoFilter1.map((item) => ({
                    label: item.nombre,
                    value: item.id,
                  }))
                : []
            }
            options={
              grupotTecnico &&
              grupotTecnico.map((item) => ({
                label: item.nombre,
                value: item.id,
              }))
            }
          ></MySelect>

          <Label
            for="tecnico_asignado"
            className="col-form-label col-sm-4 d-flex"
          >
            <strong>Asignado a</strong>
          </Label>

          <MySelect
            id="tecnico_asignado"
            name="tecnico_asignado"
            placeholder="Seleccione"
            defaultValue={
              Array.isArray(filteredtest)
                ? filteredtest.map((item) => ({
                    label: item.first_name,
                    value: item.id,
                  }))
                : []
            }
            options={
              sd &&
              sd.map((item) => ({ label: item.first_name, value: item.id }))
            }
            onChange={(item) =>
              setFormData({
                ...formData,
                tecnico_asignado: item && item.map((item) => item.value),
              })
            }
            isDisabled={
              casoDetallado.estatus === "FINALIZAR"
                ? true
                : groups === "SuperAdmin" || groups === "Supervisor"  || groups === "INGENIERO"
                ? false
                : true
            }
            isMulti
            allowSelectAll
          />
        </Col>

        <Col lg={4} className="mb-3">
          <Label
            for="tecnico_asignado"
            className="col-form-label col-sm-8 d-flex"
          >
            <strong>Fecha para asignar </strong>
          </Label>

          <input
            className="form-control d-block"
            placeholder="text"
            defaultValue={casoDetallado.fecha_asignacion}
            onChange={(e) => onChangeFecha(e)}
            disabled={
              casoDetallado.estatus === "FINALIZAR"
                ? true
                : groups === "SuperAdmin" || groups === "Supervisor"  || groups === "INGENIERO"
                ? false
                : true
            }
            type="date"
          />
        </Col>

        <Col lg={4} className="mb-3">
          <Label for="horaentrada" className="col-form-label col-sm-8 d-flex">
            <strong>Hora de Entrada </strong>
          </Label>

          <Flatpickr
            className="form-control d-block"
            placeholder="Hora de Entrada"
            defaultValue={casoDetallado.lapso_hora_entrada}
            onInput={onChangeHoraEntrada}
            options={{
              enableTime: true,

              noCalendar: true,

              dateFormat: "H:i K",
              minuteIncrement: "15",
            }}
            disabled={
              casoDetallado.estatus === "FINALIZAR"
                ? true
                : groups === "SuperAdmin" || groups === "Supervisor"  || groups === "INGENIERO"
                ? false
                : true
            }
          />
        </Col>

        <Col lg={4} className="mb-3">
          <Label
            for="tecnico_asignado"
            className="col-form-label col-sm-6 d-flex"
          >
            <strong>Hora de Salida </strong>
          </Label>

          <Flatpickr
            className="form-control d-block"
            placeholder="Hora de Salida"
            defaultValue={casoDetallado.lapso_hora_salida}
            onInput={onChangeHoraSalida}
            options={{
              enableTime: true,

              noCalendar: true,

              dateFormat: "H:i K",
              minuteIncrement: "15",
            }}
            disabled={
              casoDetallado.estatus === "FINALIZAR"
                ? true
                : groups === "SuperAdmin" || groups === "Supervisor" || groups === "INGENIERO"
                ? false
                : true
            }
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default CasosEditComponent;
